import { Form, Radio } from 'antd';
// import type { FC } from 'react';
// import type React from 'react';
import { lazy, useEffect } from 'react';
import './index.css';
import { useQuizFormContext } from '../../hooks/quiz-form-context';
import InputDescription from '../quiz-input-show-description/quiz-input-show-description';

const BooleanInput = ({
  title,
  name,
  description,
  Error,
  questionValueOptions = [],
  indexKey,
  allInputOnchageHandler,
  questionTooltip
}) => {
  const {
    formValues,
    allFormErrorsList,
    setFormValues,
    contentFullErrorMsg,
    setContentFulErrorMsg,
    getInputValues,
  } = useQuizFormContext();
  const isCompanyLogoNotUploaded = title === 'Company Logo' && !JSON.parse(localStorage.getItem('logoUrl'))

  //TO RENDER DESCRIPTION OF INPUTS
  function ShowDescription(description) {
    return <InputDescription description={description} questionTooltip={questionTooltip} />;
  }

  //ONCHANGE FUNCTION
  function handleInputChange(e, fieldItem) {
    const { name, value } = e.target;
    if (fieldItem) {
      if (fieldItem?.fields?.outcome) {
        allInputOnchageHandler(
          indexKey,
          title,
          name,
          value,
          fieldItem.sys.id,
          fieldItem.fields?.outcome?.sys.id,
          fieldItem.fields?.override,
        );
      } else {
        allInputOnchageHandler(indexKey, title, name, value, fieldItem.sys.id);
      }
    } else {
      allInputOnchageHandler(indexKey, title, name, value);
    }
  }

  //Storing error msg value in state
  useEffect(() => {
    if (Error) {
      setContentFulErrorMsg((prev) => ({ ...prev, [name]: Error }))
    }
  }, [Error])

  return (
    <>
      <Form.Item
        label={description && ShowDescription(description)}
        name={name}
        className="input-label-container"
        required={Error ? true : false}
      >
        {isCompanyLogoNotUploaded && <p className='logo-not-found-error'>A company logo is required to select 'Yes.' Please upload it in the 'My Handbooks' section.</p>}
        {questionValueOptions.length > 0 ? (
          //For outcome based boolean question below radio group is rendered
          <>
            <Radio.Group name={name}>
              {questionValueOptions.map((fieldItem) => {
                return (
                  <Radio.Button
                    key={fieldItem.sys.id}
                    value={fieldItem.fields?.value == 'true'}
                    onChange={(e) => handleInputChange(e, fieldItem)}
                    className={
                      fieldItem.fields?.value === String(getInputValues(name, formValues)?.value)
                        ? 'input-boolean ant-radio-button-wrapper-checked'
                        : 'input-boolean'
                    }
                  >
                    <span className="input-content-text">
                      {fieldItem.fields?.value == 'true' ? 'Yes' : 'No'}
                    </span>
                  </Radio.Button>
                );
              })}
            </Radio.Group>
          </>
        ) : (
          //For non-outcome based boolean question below radio group is rendered
          <>
            <Radio.Group onChange={(e) => handleInputChange(e)} name={name}>
              <Radio.Button
                className={
                  isCompanyLogoNotUploaded ? 'input-boolean' :
                    String(getInputValues(name, formValues)?.value) == 'true'
                      ? 'input-boolean ant-radio-button-wrapper-checked'
                      : 'input-boolean'
                }
                value={true}
                disabled={isCompanyLogoNotUploaded}
              >
                <span className="input-content-text">Yes</span>
              </Radio.Button>
              <Radio.Button
                className={
                  String(getInputValues(name, formValues)?.value) == 'false'
                    ? 'input-boolean ant-radio-button-wrapper-checked'
                    : 'input-boolean'
                }
                value={false}
              >
                <span className="input-content-text">No</span>
              </Radio.Button>
            </Radio.Group>
          </>
        )}
      </Form.Item>
      {allFormErrorsList[name] && <span className="error-message">{Error}</span>}
    </>
  );
};

export default BooleanInput;
